import type { BootstrapResponse } from "../api/schemas";
import { ELYSIUM } from "./elysium";

/** Legacy/demo protocol default; connected runtime selects its target explicitly. */
export const DEFAULT_SOURCE_CHAIN_ID = 4_663;
export function connectedSourceChainId(): number {
  return import.meta.env.VITE_CONNECTED_DEPLOYMENT === "ROBINHOOD_LEGACY" ? DEFAULT_SOURCE_CHAIN_ID : ELYSIUM.chainId;
}

export function terminalChains(bootstrap: BootstrapResponse | null) {
  return {
    source: bootstrap?.sourceChainId ?? connectedSourceChainId(),
    siwe: bootstrap?.siwe.chainId ?? connectedSourceChainId(),
    execution: bootstrap?.contracts.mintChainId ?? null,
  };
}

export function chainLabel(chainId: number | null): string {
  return chainId === 99901 ? "Elysium · 99901" : chainId === DEFAULT_SOURCE_CHAIN_ID ? `Robinhood · ${chainId}` : `Chain ${chainId ?? "—"}`;
}
